import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import queryString from 'query-string';

import { useTransl } from 'shared/lib/i18n';

import DeliverySelfSingOutComponent from './DeliverySelfSingOutComponent';

import { exchangeToken } from '../Auth/actionCreators';
import { getBuilding, getBuildingUnits } from '../Building/actionCreators';

import { searchObjectByKeyValue } from '../../utils';
import { getServiceData } from '../Navigation/utils';

import { ADD_DELIVERY, DELIVERY_SIGN_OUT } from './constants';

import * as unitSelectors from '../Unit/selectors';

import ErrorBoundary from '../Main/ErrorBoundary';
import { CUSTOM } from '../Modal/modalTypes';

const DeliverySelfSingOutContainer = (props) => {
  const { t } = useTransl();
  const {
    location,
    exchangeToken,
    getBuilding,
    getBuildingUnits,
    units,
    getServiceData,
  } = props;
  const { token, buildingId } = queryString.parse(location?.search);

  const [isValidQr, setIsValidQr] = useState(token && buildingId);
  const [modalData, setModalData] = useState({});
  const [search, setSearch] = useState('');

  const onLoad = async () => {
    const jwtToken = await exchangeToken(token);

    if (jwtToken) {
      getBuilding(buildingId);
      getBuildingUnits(buildingId);
      getServiceData();
    } else {
      setIsValidQr(false);
    }
  };

  useEffect(() => {
    isValidQr && onLoad();
  }, []);

  const filteredUnits = search
    ? searchObjectByKeyValue(units, 'name', search)
    : units;

  const addDeliveryModalProps = {
    modalName: ADD_DELIVERY,
    modal: {
      modalType: CUSTOM,
      modalProps: {
        title: t('delivery.add'),
      },
    },
    onModalClose: () => setModalData({}),
  };

  const getDeliverySignOutModalProps = (id, name) => ({
    modalName: DELIVERY_SIGN_OUT,
    modal: {
      modalType: CUSTOM,
      modalProps: {
        title: t('delivery.deliverySignOut'),
        maxWidth: 'md',
      },
    },
    unit: {
      id,
      name,
      parentProperty: buildingId,
      recipientId: null,
    },
    onModalClose: () => setModalData({}),
  });

  return (
    <ErrorBoundary>
      <DeliverySelfSingOutComponent
        isValidQr={isValidQr}
        units={filteredUnits}
        modalData={modalData}
        setModalData={setModalData}
        addDeliveryModalProps={addDeliveryModalProps}
        buildingId={buildingId}
        search={search}
        setSearch={setSearch}
        getDeliverySignOutModalProps={getDeliverySignOutModalProps}
      />
    </ErrorBoundary>
  );
};

DeliverySelfSingOutContainer.propTypes = {
  exchangeToken: PropTypes.func.isRequired,
  getBuilding: PropTypes.func.isRequired,
  getBuildingUnits: PropTypes.func.isRequired,
  getServiceData: PropTypes.func.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  units: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => ({
  units: unitSelectors.getUnits(state),
});
const mapDispatchToProps = (dispatch) => ({
  exchangeToken: (token) => exchangeToken(dispatch, { token }),
  getBuilding: (buildingId) => getBuilding(dispatch, buildingId),
  getBuildingUnits: (buildingId) => getBuildingUnits(dispatch, {}, buildingId),
  getServiceData: () => getServiceData(dispatch),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliverySelfSingOutContainer);
